import { useMemo, useState } from 'react'

import { toDecimalYear } from '@/pages/ui/utils'

import { LAST_VISA_BULLETIN_TREND_TIMEFRAME_VALUE } from './constants'
import { type VisaBulletinTrendCardProps } from './visa-bulletin-trend-card'

export type UseVisaBulletinTrendCardParams = Pick<VisaBulletinTrendCardProps, 'visaBulletinTrendData'>

export const useVisaBulletinTrendCard = ({ visaBulletinTrendData }: UseVisaBulletinTrendCardParams) => {
  const [currentTimeFrame, setCurrentTimeFrame] = useState(LAST_VISA_BULLETIN_TREND_TIMEFRAME_VALUE)

  const handleChangeTimeFrame = (value: string) => {
    setCurrentTimeFrame(value)
  }

  const monthlyVisaBulletinTrendData = useMemo(() => {
    if (!visaBulletinTrendData) {
      return null
    }

    const monthlySeriesDataEnhanced = visaBulletinTrendData.map(
      ({ bulletinDate, filingDate, finalActionDate, filingDateType, finalActionDateType }) => {
        return {
          date: bulletinDate,
          filingDate: filingDate ? new Date(filingDate).getTime() : null,
          finalActionDate: finalActionDate ? new Date(finalActionDate).getTime() : null,
          filingDateDecimalYear: filingDate ? toDecimalYear(filingDate) : null,
          finalActionDateDecimalYear: finalActionDate ? toDecimalYear(finalActionDate) : null,
          filingDateType,
          finalActionDateType,
        }
      }
    )

    return monthlySeriesDataEnhanced.slice(-parseInt(currentTimeFrame, 10))
  }, [visaBulletinTrendData, currentTimeFrame])

  return {
    currentTimeFrame,
    monthlyVisaBulletinTrendData,
    handleChangeTimeFrame,
  }
}
